<script context="module" lang="ts">
	import type { SectionConfig } from '$lib/util/pagebuilder';
	import { gql } from 'graphql-request';
	import Media from '$lib/components/media/Media.svelte';
	import Section from '$lib/components/layout/Section.svelte';

	export const config: SectionConfig = {
		collection: 'section_logo',
		availableFor: ['pages'],
		query: gql`
        internal_name
        is_recommendation
        translations {
            languages_code {
				code
				}
				title
			}
        items {
          section_logo_item_id {
			media {
			...Media}
			}
          }

    `
	};

	// optional: define a type for the props (note: injectTranslations is applied)
	type Props = {
		title: string;
		is_recommendation: boolean;
		items: {
			section_logo_item_id: {
				title: string;
				media: any;
			};
		}[];
	};
</script>

<script lang="ts">
	import { Marquee } from 'svelte-fast-marquee';
	import { onMount } from 'svelte';

	export let data: Props; // the components gets all data via this prop (additionally each top level prop is directly provided to the component)

	let isLoading = true;

	onMount(() => {
		setTimeout(() => {
			isLoading = false;
		}, 500);
	});
	const items = [...data.items, ...data.items];
</script>

{#if data.is_recommendation}
	<Section type="full">
		<div class="title">
			{data.title}
		</div>
		{#if !isLoading}
			{#if data.items}
				<Marquee play={true} pauseOnHover={false} pauseOnClick={false} speed={50} direction="right">
					<div class="marquee">
						{#each items as { section_logo_item_id: item }}
							<div class="wrapper">
								{#if item.media}
									<Media {...item.media} fit="contain" transform="m" />
								{/if}
							</div>
						{/each}
					</div>
				</Marquee>
			{/if}
		{/if}
	</Section>
{:else}
	<div class="award-section">
		<Section gapType="padding">
			<div slot="background" class="background" />
			<div class="content">
				<div class="desktop-award-section">
					<div class="title-award">
						{data.title}
					</div>
					<div class="award-wrapper">
						{#each data.items as { section_logo_item_id: item }}
							<div class="award-logo">
								<Media {...item.media} fit="contain" transform="l" />
							</div>
						{/each}
					</div>
				</div>
				<div class="mobile-award-section">
					<div class="title-award">
						{data.title}
					</div>
					{#if !isLoading}
						<Marquee
							play={true}
							pauseOnHover={false}
							pauseOnClick={false}
							speed={15}
							direction="right"
						>
							<div class="mobile-award-wrapper">
								{#each items as { section_logo_item_id: item }}
									<div class="mobile-award-logo">
										{#if item.media}
											<Media {...item.media} fit="contain" transform="l" />
										{/if}
									</div>
								{/each}
							</div>
						</Marquee>
					{/if}
				</div>
			</div>
		</Section>
	</div>
{/if}

<style lang="scss">
	.marquee {
		display: flex;
		gap: v(content-gap-4xl);
		overflow: hidden;
		@include media(tablet) {
			gap: v(content-gap);
		}
	}

	.title {
		@include font(h4);
		text-align: center;
		margin-bottom: v(content-gap-lg);
	}
	.wrapper {
		:global(img) {
			height: 30px;
			width: 100%;
			max-width: 250px;
		}
		&:last-child {
			padding-right: v(content-gap-4xl);
			@include media(tablet) {
				padding-right: v(content-gap);
			}
		}
	}
	.award-section {
		:global(section) {
			padding: v(content-padding-sm) !important;
			display: flex;
			@include media(tablet) {
				padding: v(content-padding-sm) 0 !important;
			}
		}

		:global(.background) {
			background-color: color(yellow) !important;
		}
	}

	.desktop-award-section {
		display: flex;
		gap: v(content-gap-xl);
		align-items: center;
		justify-content: center;
		@include media(tablet) {
			display: none;
		}
	}

	.title-award {
		@include font(h5);
		@include media(tablet) {
			margin-bottom: v(content-gap-sm);
		}
	}
	.award-wrapper {
		display: flex;
		gap: v(content-gap-xl);
	}

	.mobile-award-section {
		display: none;
		@include media(tablet) {
			display: flex;
			flex-direction: column;
			align-items: center;
		}
	}
	.mobile-award-wrapper {
		display: flex;
	}
	.mobile-award-wrapper {
		gap: v(content-gap-xl);
	}
	.mobile-award-logo {
		&:last-child {
			padding-right: v(content-gap-xl);
		}
	}
</style>
